import React from 'react';
import './Node.css';

class Node extends React.Component {
  handleClick = (e) => {
    this.setState({clicked: !this.state.clicked});
    this.props.handleClickedNodes({id: this.props.id, distance: this.props.distance});
  }

  state = {
    clicked: false
  }

  render() {
    //const alphabets = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'Y', 'Z'];
    const style = {
      left: this.props.x,
      top: this.props.y,
      borderRadius: this.props.pathStart === this.props.id ? `0` : `100%`,
    }

    style.border = this.props.pathEnd === this.props.id ? 
      `2px dashed rgb(89, 26, 148)` : 
      this.props.pathStart === this.props.id ? 
      `2px dashed rgb(89, 26, 148)` : 
      '2px solid transparent';
    
    if(this.props.clickedNode === this.props.id) {
      style.border = '2px solid rgb(89, 26, 148)';
    }

    return (
      <div 
        className="node" 
        style={style}
        onClick={this.handleClick}
      >
        <p>{this.props.id}</p>
      </div>
    )
  }
}

export default Node;
